var Utils = require("./utils");
var queryArray = Utils.queryArray;
require("whatwg-fetch");

var form = document.querySelector("form.form");
var formId = form && form.id;
var formFields = queryArray("input, select, textarea", form);
var pages = queryArray("form .tab");
var prevBtn = document.getElementById("prevBtn");
var nextBtn = document.getElementById("nextBtn");
var currentTab = 1; // Current tab is set to be the first tab
var steps = queryArray(".step-wrapper");
var alert = document.getElementById("alert");
var maxPageTab = pages.length;

if (steps && steps.length) {
  steps.forEach(function (step) {
    step.addEventListener("click", function (e) {
      if (
        step.classList.contains("btn--form") ||
        step.classList.contains("finish")
      ) {
        e.preventDefault();
        nextPrev(parseInt(step.getAttribute("data-page")));
      }
    });
  });
}

prevBtn && prevBtn.addEventListener("click", function (e) {
  e.preventDefault();
  nextPrev(currentTab - 1);
});
nextBtn && nextBtn.addEventListener("click", function (e) {
  e.preventDefault();
  nextPrev(currentTab + 1);
});

function fixStepIndicator(newTab) {
  // This function removes the "active" class of all steps...
  steps.forEach(function (step) {
    step.classList.remove("active");
    if (step.getAttribute("data-page") <= newTab) {
      step.classList.add("active");
    }
  });
}

function showTab(newTab) {
  // ... and run a function that displays the correct step indicator:
  fixStepIndicator(newTab);
  pages.forEach(function (page) {
    page.classList.remove("active");
  });

  document
    .querySelector(".tab[data-page='" + newTab + "']")
    .classList.add("active");
  document.querySelector("form.form").scrollIntoView();
}

function updateMultistepTab(newTab) {
  // ... and fix the Previous/Next buttons:
  if (newTab <= 1) {
    prevBtn.style.display = "none";
  } else {
    prevBtn.style.display = "inline";
  }
  if (newTab == maxPageTab) {
    nextBtn.innerHTML = "Submit";
  } else {
    nextBtn.innerHTML = "Next";
  }
  // ... and run a function that displays the correct step indicator:
  var step = document.querySelector(
    ".step-wrapper[data-page='" + currentTab + "']"
  );
  step.classList.add("finish");
}

function nextPrev(newTab) {
  var cancelledRenewalBool =
    formId == "membership-renewal" &&
    document.getElementById("renewalStatus") &&
    document.getElementById("renewalStatus").value == "false";
  // Exit the function if any field in the current tab is invalid:
  if (cancelledRenewalBool) {
    if (
      window.confirm("Are you sure you want to cancel this company membership?")
    ) {
      formFunctions.submitForm();
    }
  }

  if (currentTab + 1 == maxPageTab && formId == "registration") {
    formHelpers.populateRegistrationSummary(formFields);
  }
  if (newTab > currentTab) {
    if (formId == "registration") {
      var companyField = document.getElementById("company");
      var companyIdField = document.getElementById("companyId");
      if (companyIdField) {
        var option = document.querySelector(
          "select#companyId option[value='" + companyIdField.value + "']"
        );
        companyField.value = option.innerHTML;
        value = option.innerHTML;
      }
    }
    var validate = validatePage(currentTab);
    if (!validate) {
      return false;
    }
    if (formId == "member-app") {
      formHelpers.updateToLocalStorage(formFields, currentTab, pages);
    }
  }
  currentTab = newTab;

  if (currentTab > maxPageTab) {
    formFunctions.submitForm();
  } else if (!cancelledRenewalBool) {
    showTab(currentTab);
    updateMultistepTab(currentTab);
  }
  return true;
}

function validatePage(newTab) {
  // This function deals with validation of the form fields
  // checks if taking a step back
  if (currentTab > newTab) {
    alert.innerHTML = "";
    return true;
  }
  return confirmPageFieldsValid();
}

function validateListReviewed(currentTab) {
  var listIsReviewed = true;
  var listItems = queryArray(".tab[data-page='" + currentTab + "'] .type-list .row");
  listItems.slice(1, listItems.length).forEach(function(item){
    // If an item still has a review button and delete button, then this item hasn't been reviewed and 
    if (!item.classList.contains("new") && !item.classList.contains("updated") && !item.classList.contains("verify") && !item.classList.contains("delete")){
      listIsReviewed = false;
    }
  });
  if (!listIsReviewed) {
    document.querySelector("form.form").scrollIntoView();
    alert.innerHTML =
      "Some items require your attention. Please see the items below with a white background and either verify, review or mark them for deletion.";
    return false;
  }
  alert.innerHTML = "";
  return true;
}

function confirmPageFieldsValid() {
  var invalidFields = [];
  var requiredFields = queryArray(
    ".tab[data-page='" + currentTab + "'] [required]"
  );
  var inputFields = queryArray(".tab[data-page='" + currentTab + "'] input");

  // check if there is a list of items to be reviewed on this page
  if (formId == "membership-renewal" && currentTab == 3 || currentTab == 5) {
    return validateListReviewed(currentTab);
  }
  // check if there is a .type-form on this page- if inactive then can skip verifying those fields
  requiredFields = window.formTypeHelpers.validatePageTypeForms(
    requiredFields,
    inputFields,
    currentTab
  );

  //check if there are hidden required parent dependent fields
  var parentDependentFields = queryArray(".tab[data-page='" + currentTab + "'] [data-dependent='true'] [required]");
  if (parentDependentFields && parentDependentFields.length > 0) {
    requiredFields = requiredFields.filter(function (reqField) {
      return parentDependentFields.includes(reqField) && !reqField.classList.contains("hidden");
    });
  }

  //check if mailing address different from company - if not, then those fields not required
  var sameAddressFields = queryArray(
    ".tab[data-page='" + currentTab + "'] .same-address"
  );
  sameAddressFields.forEach(function (sameAddressField) {
    if (sameAddressField.checked) {
      var type = sameAddressField.getAttribute("data-type");
      var addressBlockFields = queryArray(
        "[required]",
        document.querySelector(".address-block[data-type='" + type + "']")
      );
      requiredFields = requiredFields.filter(function (reqField) {
        addressBlockFields.indexOf(reqField) === -1;
      });
      inputFields = inputFields.filter(function (reqField) {
        addressBlockFields.indexOf(reqField) === -1;
      });
    }
  });

  //check if the form is a registration and has a guest - if not, guest fields not required
  if (formId == "registration") {
    requiredFields = window.registrationFormHelpers.guestFieldFilter(requiredFields);
  }

  requiredFields.forEach(function (field) {
    if ((field.type == "checkbox" && !field.checked) || field.value == "") {
      invalidFields.push(field);
    } else {
      field.classList.remove("is-invalid");
    }
  });

  inputFields.forEach(function (field) {
    var pattern = field.getAttribute("pattern");
    if (
      pattern &&
      field.value &&
      field.value != "" &&
      !new RegExp(pattern).test(field.value)
    ) {
      invalidFields.push(field);
    } else {
      field.classList.remove("is-invalid");
    }
  });

  if (invalidFields.length) {
    invalidFields.forEach(function (field) {
      field.classList.add("is-invalid");
    });
    document.querySelector("form.form").scrollIntoView();
    alert.innerHTML =
      "Some required fields do not match the required format. Please check the fields we highlighted below.";
    return false;
  } else {
    alert.innerHTML = "";
    return true;
  }
}

window.multistepFormHelpers = {
  showTab: showTab,
  validatePage: validatePage,
  confirmPageFieldsValid: confirmPageFieldsValid,
  fixStepIndicator: fixStepIndicator,
  nextPrev: nextPrev,
  updateMultistepTab: updateMultistepTab,
};
